import { render, staticRenderFns } from "./accuracy-chart.vue?vue&type=template&id=b57151b0&scoped=true"
import script from "./accuracy-chart.vue?vue&type=script&lang=js"
export * from "./accuracy-chart.vue?vue&type=script&lang=js"
import style0 from "./accuracy-chart.vue?vue&type=style&index=0&id=b57151b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57151b0",
  null
  
)

export default component.exports